module.exports = __webpack_public_path__ + "img/img12.79c33c22.png";